import React, { useState, useEffect, useContext, useRef } from 'react';

import { Checkbox, Modal } from 'antd';

import SimpleTable from '../../components/tables/simpleTable';
import 'antd/dist/reset.css';

import SalesSimpleTable from '../../components/tables/salesTable';
import toast, { Toaster } from 'react-hot-toast';
import TrashModal from '../../components/modals/trashModal';
import RecoverModal from '../../components/modals/recoverModal';
import AddModal from '../../components/modals/addModal';
import EditModal from '../../components/modals/editModal';
import DeleteModal from '../../components/modals/deleteModal';
import EndOfDayModal from '../modals/endOfDayModal';
import CartModal from '../../components/modals/cartModal';

import SearchFilter from '../../components/filters/search';
import CustomButton from '../../components/buttons/customButton';
import IsActiveFilter from '../../components/filters/isActive';
import AddButton from '../../components/buttons/addButton';
import DataFilter from '../../components/filters/dataFilter';
import DatePicker from '../../components/filters/datePicker';
import { Route, Routes, useNavigate } from 'react-router-dom';
import Loader from '../../components/loader/loader';
import { numberFormatter, totalFormatter } from '../../components/formatters/numberFormatter';
import { dateFormatter } from '../../dynamic/dateFormatter';
import { typeFormatter } from '../../components/formatters/defFormatter';
import { clientOrderColumnDefs } from '../../components/tables/columnDefs';
import { dateTableFormatter } from '../../dynamic/dateFormatter';
import { creditFormatter, debitFormatter } from '../../components/formatters/defFormatter';
import { PrinterOutlined } from '@ant-design/icons';
import { Input, Tag, Button } from 'antd';
import AntdSelect from 'antd/lib/select';
import { FcKindle } from "react-icons/fc";

import Select from 'react-select';
import { Col, Form, Row } from 'react-bootstrap';

import { ClockCircleOutlined, HddOutlined, UserOutlined } from '@ant-design/icons';

import { FiEdit } from "react-icons/fi";
import { FcUndo, FcViewDetails, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash } from "react-icons/bi";
import { FaDollarSign, FaLink } from "react-icons/fa";
import { FaTurkishLiraSign } from "react-icons/fa6";
import { TbTruckDelivery } from "react-icons/tb";

import { DataContext } from '../../init/getData';
import DropDownFilter from '../../components/filters/dropDownFilter';
import PrintEndSessionModal from '../../components/print/PrintEndSession';



const { TextArea } = Input;


function Sales(props) {

  let { type, isOrder } = props;


  let { userData, settingData, serverApi, localApi, devData, refAllUserData, allUserData, refAccountData, accountData, session, sessionId, setAccess } = useContext(DataContext);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState();   
  const createdBy = userData.id;
  const userRole = userData.role;
  const navigate = useNavigate();

  let api;

  if (!devData?.isServer && !devData?.isCloud) {

    api = serverApi;

  } else {

    api = localApi;

  }


  useEffect(() => {
    setFilter(prevFilter => ({ ...prevFilter, isOrder: isOrder }));
  }, [type]);




  const today = new Date().toISOString().split('T')[0];

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const defaultWareHouseId = userData?.role?.defaultWareHouseId;
  const wareHouseSaleId = userData.role.wareHouseSaleId;
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);


  let wareHouseId = settingData.showWareHouseInSales ? defaultWareHouseId : wareHouseSaleId;

  if (devData.isCloud) {
    wareHouseId = null;
    sessionId = null;
  }


    const [filter, setFilter] = useState({
      search: '',
      isActive: 'true',
      fromDate: settingData.filterSalesByDate ? null : today,
      toDate: settingData.filterSalesByDate ? null : today,
      isOrder: isOrder,
      createdBy: userRole.viewAllSales ? null : createdBy,
      wareHouseId: wareHouseId,
      sessionId: settingData.filterSalesByDate ? null : sessionId
    });


  const [showAddModal, setShowAddModal] = useState(false);
  const [showEndOfDayModal, setShowEndOfDayModal] = useState(false);
  
  const [showTrashModal, setShowTrashModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const [showCartModal, setShowCartModal] = useState(false);

  const [name, setName] = useState('');
  const [region, setRegion] = useState('');
  const [address, setAddress] = useState('');
  const [delivery, setDelivery] = useState('');
  const [totalUsd, setTotalUsd] = useState(0);
  const [totalLbp, setTotalLbp] = useState(0);
  const [conditions, setConditions] = useState([]);

  const [showEndSessionModal, setShowEndSessionModal] = useState(false);
  const [showPrintEndOfDayModal, setShowPrintEndOfDayModal] = useState(false);
  const [allTransactionsData, setAllTransactionsData] = useState(null);  
  const [currentSession, setCurrentSession] = useState(null);
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [sessionData, setSessionData] = useState(null);



  const table = 'transaction';
  const title = 'Sales';






  //Get Data refs 
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!devData.isCloud) {
          await refAllUserData();
          await refAccountData();
        }
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);

  const handlePrintSession = async () => {
    try {
      setIsLoading(true);
      // Fetch the current session data with transactions
      const sessionResponse = await api.get(`session/getSessionById/${sessionId}`);
      if (sessionResponse.data.status) {
        setSessionData(sessionResponse.data.data);
        setShowPrintModal(true);
      } else {
        toast.error("Failed to fetch session data");
      }
    } catch (error) {
      toast.error("Failed to fetch session data. Contact Support");
    } finally {
      setIsLoading(false);
    }
  };

  const handlePrintEndOfDay = async () => {
  try {
    setIsLoading(true);
    
    // Fetch ALL transactions without date filtering
    const data = {
      filter: {
        type: ['Sale', 'Return'],
        isActive: true, 
        isOrder: false,
        // Remove date filters to get all rows
        fromDate: null,
        toDate: null,
        // Remove session filter for cloud environment
        sessionId: devData.isCloud ? null : sessionId
      },
    };

    const response = await api.get(`transaction/getall`, { params: data });
    
    if (response.data.status) {
      setAllTransactionsData(response.data.data);
      console.log('All Transactions:', allTransactionsData);
      setShowPrintEndOfDayModal(true);
    } else {
      toast.error("Failed to fetch transactions data");
    }
  } catch (error) {
    toast.error("Failed to fetch transactions data. Contact Support");
  } finally {
    setIsLoading(false);
  }
};

  const signOut = () => {
    toast.success('Logged out');
    setAccess(false);
    if (navigate) {
      navigate('/');
    }
  };


  const confirmEndSession = () => {
    setShowEndSessionModal(true);
  };

  const endSession = async () => {
    try {
      setIsLoading(true);
      const endResponse = await api.post(`session/end`, { sessionId });

      if (endResponse.data.status) {
        toast.success("Session ended successfully");
        signOut();
        setShowEndSessionModal(false);
      } else {
        toast.error(endResponse.data.message || "Failed to end session");
      }
    } catch (error) {
      toast.error("Failed to end session. Contact Support");
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    if (!session) {
      // if no active session found, log out
      setAccess(false);
    }
  }, [session]);



  const deliveryData = accountData.filter(item => item.type === 'Delivery');

  // Delivery Options
  const deliveryOptions = deliveryData?.map(item => ({
    value: item.id,
    label: `${item?.name} [${item?.phone}]`,
  }))
  deliveryOptions.push({ value: null, label: 'All ' + devData.deliveryName })
  const selectedDelivery = deliveryOptions.filter(option => option.value === filter.deliveryId);


  // Users Options
  const userOptions = allUserData?.map(item => ({
    value: item.id,
    label: item?.name,
  }))
  userOptions.push({ value: null, label: 'All Users' })
  const selectedUser = userOptions.filter(option => option.value === filter.createdBy);


  //change Type  
  useEffect(() => {
    setFilter(prevFilter => ({ ...prevFilter, type: type, }));
  }, [type]);

  const handleCreateInvoices = () => {
    if (selectedRowKeys.length > 0) {
      createInvoicesForSelectedRows(selectedRowKeys);
    } else {
      toast.error('Please select at least one row to create invoices');
    }
  };

  useEffect(() => {
    setSelectedRowKeys([...selectedRowKeys]); // Force re-render
  }, []);





  const cartModal = (e) => {
    if (!showCartModal) {
      setIdRow(e);
    }
    setShowCartModal(!showCartModal);
  }


  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  const recoverModal = (e) => {
    if (!showRecoverModal) {
      setIdRow(e);
    }
    setShowRecoverModal(!showRecoverModal);
  }

  const trashModal = (e) => {
    if (!showTrashModal) {
      setIdRow(e);
    }
    setShowTrashModal(!showTrashModal);
  }

  const deleteModal = (e) => {
    if (!showDeleteModal) {
      setIdRow(e);
    }
    setShowDeleteModal(!showDeleteModal);
  }

  const editModal = (e) => {
    if (!showEditModal) {
      setIdRow(e);
    }
    setShowEditModal(!showEditModal);
  }

  const endOfDayModal = (e) => {
    if (!showEndOfDayModal) {
      setIdRow(e);
    }
    setShowEndOfDayModal(!showEndOfDayModal);
  }

  const createInvoicesForSelectedRows = async (selectedRowKeys) => {
    try {
      const responses = await Promise.all(
        selectedRowKeys.map(async (id) => {
          const res = await api.post(`transaction/createInvoice`, { transactionId: id });
          return res.data;
        })
      );


      responses.forEach((response, index) => {
        if (response.status) {
          toast.success(`Invoice created for transaction ID: ${selectedRowKeys[index]}`);
        } else {
          toast.error(`Failed to create invoice for transaction ID: ${selectedRowKeys[index]}`);

        }
      });
      setRefreshTable((prev) => !prev);



    } catch (error) {
      toast.error("An error occurred while creating invoices");
    }
  };


  //Excel Data
  const getExcelData = (data) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        id: item.id,
        createdAt: item.createdAt,

        account: item.account?.name,
        delivery: item.delivery?.name,
        total: item.total,
        discount: item.discount,
        type: item.type,
        isCredit: item.isCredit,
        details: item.details,
      };

      transformedData.push(newItem);
    });

    return { transformedData };
  };

  const handleRowSelection = (id) => {
    setSelectedRowKeys((prevSelected) => {
      const newSelected = prevSelected.includes(id)
        ? prevSelected.filter((key) => key !== id) // Deselect if it's already selected
        : [...prevSelected, id]; // Select if it's not already selected

      return newSelected;
    });
  };






  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRowKeys(data?.data?.map((row) => row.id) || []); // Select all rows
    } else {
      setSelectedRowKeys([]); // Deselect all rows
    }
  };







  let newColumnDefs = [
    {
      title: (
        <Checkbox
          onChange={handleSelectAll}  // Handle the "select all" logic
          indeterminate={selectedRowKeys.length > 0 && selectedRowKeys.length < data?.data?.length}
        />
      ),
      dataIndex: "checkbox",
      width: "5%",
      render: (_, record) => (
        <Checkbox
          onChange={() => handleRowSelection(record.id)} // Handle the selection logic
        // No need to use checked prop here, the state is controlled by selectedRowKeys already
        />
      ),


    },
    { title: 'ID', dataIndex: 'newId', width: '6%', sorter: (a, b) => a.age - b.age },
    { title: 'CreatedAt', dataIndex: 'createdAt', render: dateTableFormatter },
    {
      title: 'Account',
      dataIndex: 'account',
      render: (account, record) => {
        if (devData.isCloud) {
          return record?.accountNameCloud;
        } else {
          return account?.name;
        }
      }
    },
    {
      title: devData.deliveryName,
      dataIndex: 'delivery',
      render: (delivery, record) => {
        if (devData.isCloud) {
          return record?.deliveryNameCloud;
        } else {
          return delivery?.name;
        }
      }
    },
    { title: 'Total In', dataIndex: 'total', width: '8%', render: debitFormatter },
    { title: 'Total Out', dataIndex: 'total', width: '8%', render: creditFormatter },
    { title: 'Discount %', dataIndex: 'discount', width: '8%', render: numberFormatter },
    { title: 'Type', dataIndex: 'type', render: typeFormatter },
    { title: 'Details', dataIndex: 'details' },
    { title: 'User', dataIndex: 'created', render: (created) => (created?.name) },
  ];

  useEffect(() => {

  if (filter.isActive == 'true') {
    newColumnDefs.push(
      {
        title: 'View',
        width: '5%',
        render: (_, record) => (
          <FcKindle size={18} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => cartModal(record)} />
        ),
      }
    );
    
    // Only add Trash column if user has permission
    if (userRole?.trashOrderAction) {
      newColumnDefs.push({
        title: 'Trash',
        width: '5%',
        render: (_, record) => (
          <BiSolidTrash size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => trashModal(record)} />
        )
      });
    }
  } else {
    newColumnDefs.push(
      {
        title: 'Deleted At',
        dataIndex: 'deletedAt',
        render: dateTableFormatter,
      },
      {
        title: 'View',
        width: '5%',
        render: (_, record) => (
          <FcKindle size={18} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => cartModal(record)} />
        ),
      }
    );
  }
  
  setColumnDefs(newColumnDefs);
}, [filter.isActive, userRole?.trashOrderAction]);


  useEffect(() => {
    setFilter(prev => ({
      ...prev,
      fromDate: settingData.filterSalesByDate ? today : null,
      toDate: settingData.filterSalesByDate ? today : null
    }));
  }, [settingData.filterSalesByDate]);





  const formView = (<div>

  </div>);




  const modalFooter = (
    <div>


    </div>
  );

  const tableFooter = (

    <div style={{ display: 'flex', justifyContent: 'space-between', position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>
      <div>
        {data?.summary?.totalSalesCredit > 0 &&
          <span className='table-footer footer-yellow'>Credit: {numberFormatter(data?.summary?.totalSalesCredit, 2)} {settingData.currency}</span>
        }
        <span className='table-footer footer-green'>Cash:   {numberFormatter(data?.summary?.totalSalesCash, 2)} {settingData.currency}</span>
      </div>
    </div>

  );


  return (
    <div className='card'>

      {isLoading &&
        <Loader />
      }


      {!isLoading && filter.type &&
        <>
          <div>

            <SearchFilter setFilter={setFilter} />
            <IsActiveFilter setFilter={setFilter} />

            {settingData.filterSalesByDate && (
              <DatePicker setFilter={setFilter} filter={filter} />
            )}


            {userRole.viewAllSales &&
              <DataFilter selectedOption={selectedUser} setFilter={setFilter} dataOptions={userOptions} filterBy={'createdBy'} placeHolder={'All Users'} />
            }

            {(isOrder && !devData.isCloud) &&
              <DataFilter selectedOption={selectedDelivery} setFilter={setFilter} dataOptions={deliveryOptions} filterBy={'deliveryId'} placeHolder={'All ' + devData.deliveryName} />
            }



            {!devData.isServer && devData.isCloud &&
              <CustomButton tittle={'end of day'} color={'#e64450'} method={() => setShowEndOfDayModal(!showEndOfDayModal)} />
            }

            {!devData.isCloud && !settingData.filterSalesByDate && (
              <CustomButton tittle={'end session'} color={'#e64450'} method={confirmEndSession} />
            )}

            {settingData.showWareHouseInSales &&
              <DropDownFilter setFilter={setFilter} filterBy={'wareHouseId'} placeHolder={'All ' + devData.wareHouseName} filter={filter} setLoadingCounter={() => setLoadingCounter((prevCounter) => prevCounter + 1)} />
            }

            {(isOrder &&
              <Button type="primary" onClick={handleCreateInvoices}>
                Create Invoices
              </Button>
            )}






          </div>


          {showEndSessionModal && (
            <Modal
              title="End Current Session"
              open={showEndSessionModal}
              onCancel={() => setShowEndSessionModal(false)}
              footer={[
                <Button key="cancel" onClick={() => setShowEndSessionModal(false)}>
                  Cancel
                </Button>,
                <Button
                  key="print"
                  icon={<PrinterOutlined />}
                  onClick={handlePrintSession}
                  loading={isLoading}
                >
                  Print
                </Button>,
                <Button
                  key="end"
                  type="primary"
                  danger
                  loading={isLoading}
                  onClick={endSession}
                >
                  End Session
                </Button>,
              ]}
            >
              <p>Are you sure you want to end your current session?</p>
              <p>You can print a session report before ending the session.</p>

              {/* Session Info */}
              <div style={{ marginBottom: '20px', fontSize: '14px', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                <Row className="mb-1">
                  <Col md={4} style={{ fontWeight: 600 }}>Opened At:</Col>
                  <Col md={8}>{dateTableFormatter(session?.openedAt)}</Col>
                </Row>
                <Row className="mb-1">
                  <Col md={4} style={{ fontWeight: 600 }}>Session Id:</Col>
                  <Col md={8} style={{ fontWeight: 600 }}>{session?.id}</Col>
                </Row>
                <Row className="mb-1">
                  <Col md={4} style={{ fontWeight: 600 }}>User:</Col>
                  <Col md={8}>{userData?.name}</Col>
                </Row>
              </div>
            </Modal>
          )}


          {showPrintModal && (
            <PrintEndSessionModal  
              sessionData={sessionData}
              visible={showPrintModal}
              onCancel={() => setShowPrintModal(false)}
            />
          )}


          <SalesSimpleTable
            filter={filter}
            table={table}
            title={title}
            columnDefs={columnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
            selectedRowKeys={selectedRowKeys} // Pass selectedRowKeys to child
            handleSelectAll={handleSelectAll} // Pass handleSelectAll to child
          />

          <TrashModal
            showModal={showTrashModal}
            toggleModal={trashModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
            data={{ transactionId: idRow.id, cart: idRow.cart, transaction: idRow, isCloud: devData.isCloud }}
          />

          {!devData.isServer && devData.isCloud &&
            <EndOfDayModal
              showModal={showEndOfDayModal}
              toggleModal={endOfDayModal}
              idRow={idRow}
              table={table}
              title={title}
              refreshTable={refreshTableFunction}
              api={api}
              handlePrintEndOfDay={handlePrintEndOfDay} // Pass the new function
              showPrintEndOfDayModal={showPrintEndOfDayModal}
              setShowPrintEndOfDayModal={setShowPrintEndOfDayModal}
              allTransactionsData={allTransactionsData}
              setAllTransactionsData={setAllTransactionsData}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
            />
            
          }


          <DeleteModal
            showModal={showDeleteModal}
            toggleModal={deleteModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
            data={{ transactionId: idRow.id, cart: idRow.cart, transaction: idRow, isCloud: devData.isCloud }}
          />

          <RecoverModal
            showModal={showRecoverModal}
            toggleModal={recoverModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
            data={{ id: idRow?.id }}
          />


          <CartModal
            showModal={showCartModal}
            toggleModal={cartModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
          />


        </>
      }

    </div>
  )
}

export default Sales; 
